<template>
  <nav v-if="showNav">
    <SettingsDialog
      v-if="showSettingsDialog"
      @close="showSettingsDialog = false"
    ></SettingsDialog>

    <v-navigation-drawer
      v-model="primaryDrawer.model"
      :permanent="primaryDrawer.type === 'permanent'"
      :temporary="primaryDrawer.type === 'temporary'"
      app
    >
      <v-list dense nav class="py-0">
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-img src="https://randomuser.me/api/portraits/lego/8.jpg" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ userName }}</v-list-item-title>
            <v-list-item-subtitle>{{ userEmail }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          color="orange darken-2"
          v-for="link in links"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar relative app top>
      <v-app-bar-nav-icon @click="primaryDrawer.model = !primaryDrawer.model">
      </v-app-bar-nav-icon>
      <v-toolbar-title class="text--primary">
        <span class="font-weight-light">tts</span>&nbsp;
        <span>Knowledge Matters</span></v-toolbar-title
      >
      <v-spacer></v-spacer>

      <v-btn icon @click.stop="showSettingsDialog = true">
        <v-icon>mdi-settings</v-icon>
      </v-btn>

      <LogoutButton />
    </v-app-bar>
  </nav>
</template>

<script>
import { getDomainRoutes } from '../config/domainRegistry/router'
import {
  FETCH_ROUTE_PERMISSIONS,
  GET_USER,
  GET_USER_EMAIL,
  GET_USER_NAME,
  MODULE_NAME as AUTH_MODULE
} from '../global/auth/store/types'
import LogoutButton from '@/global/auth/components/LogoutButton.vue'
import SettingsDialog from './SettingsDialog'

export default {
  name: 'Navbar.vue',
  components: {
    LogoutButton,
    SettingsDialog
  },
  async created() {
    try {
      const userRoutePermissions = await this.$store.dispatch(
        `${AUTH_MODULE}/${FETCH_ROUTE_PERMISSIONS}`
      )
      getDomainRoutes().then(domainRoutes => {
        domainRoutes
          .filter(route => route.meta === undefined || route.meta.displayLink)
          // .filter(route =>
          //   userRoutePermissions.routes.some(
          //     permRoute => permRoute.path === route.path
          //   )
          // )
          .forEach(route => {
            this.links.push({
              icon: route.props.icon,
              text: route.name,
              route: route.path
            })
          })
      })
    } catch (e) {}
  },
  data: () => ({
    drawer: false,
    links: [],
    showSettingsDialog: false,
    primaryDrawer: {
      model: null,
      type: 'temporary',
      clipped: false,
      floating: false,
      mini: false
    }
  }),
  computed: {
    userName() {
      const userName = this.$store.getters[`${AUTH_MODULE}/${GET_USER_NAME}`]
      return userName ? userName : 'Kein Benutzername'
    },
    userEmail() {
      const userEmail = this.$store.getters[`${AUTH_MODULE}/${GET_USER_EMAIL}`]
      return userEmail ? userEmail : 'Keine Email'
    },
    showNav() {
      return this.$route.meta === undefined || !this.$route.meta.hideNav
    }
  }
}
</script>
